import { render, staticRenderFns } from "./update-password.vue?vue&type=template&id=b9468ab0&scoped=true&"
import script from "./update-password.vue?vue&type=script&lang=js&"
export * from "./update-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9468ab0",
  null
  
)

export default component.exports